export default "__VITE_ASSET__2mJ$j4NF__"